import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { useRulerBreakpointsCount } from './useRulerBreakpointsCount'
import * as Styled from './styled'
import { formatDuration } from './utils'
import { usePlayableAreaWidth, useTimelineMaxWidth } from 'hooks/timeline'
import {
  GAP_BETWEEN_TIMELINE_AND_PLUS_BUTTON,
  TIMELINE_RULER_SLICE_WIDTH
} from 'consts'
import { useTimelineContext } from 'context/TimelineContext'

const Timescale = () => {
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )
  const { isMultiDragging } = useTimelineContext()
  const playableAreaWidth = usePlayableAreaWidth()
  const timelineMaxWidth = useTimelineMaxWidth()

  const isTimelineItemDragging = useSelector(
    editorSelectors.isTimelineItemDragging
  )
  const isTimelineItemResizing = useSelector(
    editorSelectors.isTimelineItemResizing
  )

  const width =
    isTimelineItemDragging || isTimelineItemResizing || isMultiDragging
      ? timelineMaxWidth
      : playableAreaWidth + GAP_BETWEEN_TIMELINE_AND_PLUS_BUTTON

  const linesBetweenSlices =
    timelineRulerSliceDuration > 1 ? timelineRulerSliceDuration - 1 : 0

  const { rulerRef, breakpointsCount } = useRulerBreakpointsCount()

  return (
    <Styled.RulerContainer>
      <Styled.Ruler ref={rulerRef} $width={width}>
        {Array.from({ length: breakpointsCount }, (_, index) => {
          const rulerTickLeft = index * TIMELINE_RULER_SLICE_WIDTH
          return (
            <Styled.RulerTick
              key={index}
              style={{ left: `${rulerTickLeft}px` }}
            >
              <p>{formatDuration(timelineRulerSliceDuration * index)}</p>
              {Array.from({ length: linesBetweenSlices }, (_, index) => {
                const rulerLineLeft =
                  (index + 1) *
                  (TIMELINE_RULER_SLICE_WIDTH / timelineRulerSliceDuration)
                return (
                  <Styled.RulerLine
                    key={index}
                    style={{ left: `${rulerLineLeft}px` }}
                  />
                )
              })}
            </Styled.RulerTick>
          )
        })}
      </Styled.Ruler>
    </Styled.RulerContainer>
  )
}

export default Timescale
